var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFinishedPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1726_180040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12L12 17M12 17L17 12M12 17L12 4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20H18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14C16.245 14 14 16.245 14 19C14 21.755 16.245 24 19 24C21.755 24 24 21.755 24 19C24 16.245 21.755 14 19 14ZM21.39 17.85L18.555 20.685C18.485 20.755 18.39 20.795 18.29 20.795C18.19 20.795 18.095 20.755 18.025 20.685L16.61 19.27C16.465 19.125 16.465 18.885 16.61 18.74C16.755 18.595 16.995 18.595 17.14 18.74L18.29 19.89L20.86 17.32C21.005 17.175 21.245 17.175 21.39 17.32C21.535 17.465 21.535 17.7 21.39 17.85Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.39 17.85L18.555 20.685C18.485 20.755 18.39 20.795 18.29 20.795C18.19 20.795 18.095 20.755 18.025 20.685L16.61 19.27C16.465 19.125 16.465 18.885 16.61 18.74C16.755 18.595 16.995 18.595 17.14 18.74L18.29 19.89L20.86 17.32C21.005 17.175 21.245 17.175 21.39 17.32C21.535 17.465 21.535 17.7 21.39 17.85Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1726_180040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFinishedPlayer);
export default __webpack_public_path__ + "static/media/download-finished-player.12ecf82f8a8f5416b25fb88f457dc5ef.svg";
export { ForwardRef as ReactComponent };